import { EditorView } from '@codemirror/view';
import { Compartment, Extension } from '@codemirror/state';
import { oneDark } from '@codemirror/theme-one-dark';

export const themeCompartment = new Compartment();

export const getDarkTheme = (): Extension => {
  return themeCompartment.of(oneDark);
};

export const getLightTheme = (): Extension => {
  return themeCompartment.of(
    EditorView.theme(
      {
        '.cm-editor': {
          backgroundColor: '#ffffff',
          color: '#333333',
        },
        '.cm-gutters': {
          backgroundColor: '#f5f5f5',
          borderRightColor: '#e0e0e0',
          color: '#999999',
        },
        '.cm-linenumber': {
          color: '#999999',
        },
        '.cm-cursor': {
          borderLeftColor: '#333333',
        },
        '.cm-selectionBackground': {
          backgroundColor: '#e8f3ff',
        },
        '.cm-selection': {
          backgroundColor: '#e8f3ff',
        },
        '.cm-activeLine': {
          backgroundColor: 'rgba(0, 0, 0, 0.03)',
        },
        '.cm-activeLineGutter': {
          backgroundColor: 'rgba(0, 0, 0, 0.03)',
        },
        // Syntax highlighting colors for light mode
        '.cm-string': {
          color: '#22863a',
        },
        '.cm-atom': {
          color: '#005cc5',
        },
        '.cm-number': {
          color: '#005cc5',
        },
        '.cm-property': {
          color: '#6f42c1',
        },
        '.cm-keyword': {
          color: '#d73a49',
        },
        '.cm-variable': {
          color: '#24292e',
        },
        '.cm-comment': {
          color: '#6a737d',
        },
      },
      { dark: false }
    )
  );
};
